import React, { Component, Fragment } from 'react';
import { Select, Input, Button } from 'antd';
import _, { set } from 'lodash';
import qs from 'query-string';
import $ from 'jquery';
import { __ } from '@wordpress/i18n';

import './styles.module.scss';
import Pagination from 'components/Pagination/Pagination';
import { API_HOST } from 'configs/env';
import AppHelper from 'libs/AppHelper';
import whttp from 'libs/whttp';

const INDEX_URL = _.get(window, 'VC_CONFIG.INDEX_URL');
const Locale = _.get(window, 'VC_CONFIG.Locale');

const defaultListInfo = {
  current: 1,
  page_size: 40,
  total: 1,
  rows: [],
};

export default class NewsList extends Component {
  state = {
    queryInfo: {
      search: '',
      category_name: '',
      keyword: '',
    },
    listInfo: {
      current: 1,
      page_size: '40',
      rows: [],
      total: 0,
    },
  };

  componentDidMount() {
    AppHelper.updateConfig();
    const hashQuery = AppHelper.getHashParamaters();
    if (hashQuery) {
      const { queryInfo } = this.state;
      queryInfo.search = hashQuery.search;
      queryInfo.category_name = hashQuery.category_name;
      queryInfo.keyword = hashQuery.keyword;
      this.setState({ queryInfo });
    }

    this.loadData();
  }

  loadData = (opt) => {
    const { queryInfo } = this.state;
    whttp.sharedGet(
      `${API_HOST}/api/v1/recipes?`,
      {
        'category_names[]': _.get(queryInfo, 'category_name'),
        keyword: _.get(queryInfo, 'keyword'),
        search: _.get(queryInfo, 'search'),
        page: _.get(opt, 'page', 1),
        page_size: _.get(opt, 'pageSize', 40),
      },
      (state, res) => {
        const { code = 100, reason = '發生錯誤', data = {} } = res;

        if (state === false || code !== 200) {
          return;
        }

        this.setState({ listInfo: data });
      }
    );
    const hrefQuery =
      this.state.queryInfo.search === ''
        ? qs.stringify(
            {
              category_name: _.get(queryInfo, 'category_name'),
              keyword: _.get(queryInfo, 'keyword'),
            },
            { skipNull: true }
          )
        : qs.stringify(
            {
              category_name: _.get(queryInfo, 'category_name'),
              keyword: _.get(queryInfo, 'keyword'),
              search: _.get(queryInfo, 'search'),
            },
            { skipNull: true }
          );

    window.location.href = `#${hrefQuery}`;
    window.scrollTo(0, 0);
  };

  recipeCategoriesSelect = (value) => {
    const { queryInfo } = this.state;
    queryInfo.category_name = [value];
    queryInfo.search = '';
    this.setState({ queryInfo }, () => this.loadData());
  };

  handleClickTag = (item) => {
    const { queryInfo } = this.state;
    if ($(`#${item.name}`).hasClass('active')) {
      queryInfo.keyword = '';
    } else {
      queryInfo.keyword = item.keyword;
      queryInfo.search = '';
    }
    this.setState({ queryInfo }, () => this.loadData());
  };

  handleClickHot = (item) => {
    const { queryInfo } = this.state;
    queryInfo.search = item.keyword;
    this.setState({ queryInfo }, () => this.loadData());
  };

  handleClickCategory = (item) => {
    const { queryInfo } = this.state;
    if ($(`#${item.id}`).hasClass('active')) {
      queryInfo.category_name = '';
    } else {
      queryInfo.category_name = item.name;
      queryInfo.search = '';
    }
    this.setState({ queryInfo }, () => this.loadData());
  };

  handleChangePagination = (page, pageSize) => {
    this.loadData({ page, pageSize });
  };

  render() {
    const { queryInfo, listInfo } = this.state;
    const Local = _.get(window, 'VC_CONFIG.Locale');
    const options = this.props.app.options || {};
    const recipeTags = options.recipe_tags || [];
    const recipeCategories = options.recipe_categories || [];
    const recipeList = listInfo.rows || [];
    const hotKeywords = options.hot_keywords || [];

    return (
      <Fragment>
        <main class='bg-light'>
          <div class='bg-light'>
            <div class='container'>
              <div class='breadcrumb-wrap py-4 m-0'>
                <nav aria-label='breadcrumb'>
                  <ol class='breadcrumb'>
                    <li class='breadcrumb-item'>
                      <a
                        href={`${window.VC_CONFIG.INDEX_URL}${
                          Local == 'en_US' ? '/en' : ''
                        }`}>
                        {__('首頁', 'cec-plugin-stores')}
                      </a>
                    </li>
                    <li class='breadcrumb-item active' aria-current='page'>
                      {__('廚房', 'cec-plugin-stores')}
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
          <div class='banner banner-md'>
            <div class='banner-image'>
              <img
                src={`${
                  window.VC_CONFIG.PLUGIN_ASSETS_URL
                }img/banner/kitchen/banner-kitchen.png`}
                alt=''
              />
              <h3 class='title mb-0'>{__('廚房', 'cec-plugin-stores')}</h3>
            </div>
          </div>
          <div class='bg-light'>
            <div class='container'>
              <section class='pt-5'>
                <div class='row'>
                  <div class='col-md-4 col-lg-3 mb-4'>
                    <aside>
                      <div class='kitchen-filter-aside'>
                        <div class='card'>
                          <div class='card-header'>
                            <h5
                              style={{
                                color: 'white',
                              }}>
                              {__('食譜共', 'cec-plugin-stores')}
                              <span class='reault'>{listInfo.total}</span>
                              {__('件', 'cec-plugin-stores')}
                            </h5>
                          </div>
                          <div className='search-dev'>
                            <Input
                              placeholder='請輸入食材或食譜名稱'
                              className='search'
                              onPressEnter={() => {
                                queryInfo.category_name = ''
                                queryInfo.keyword = ''
                                this.loadData()
                              }}
                              allowClear
                              value={queryInfo.search}
                              suffix={
                                <button
                                  class='icon-search mr-3 mr-md-0'
                                  style={{
                                    color: '#316ede',
                                    border: 'none',
                                    backgroundColor: 'transparent',
                                    fontSize: '20px',
                                  }}
                                  onClick={() => {
                                    queryInfo.category_name = ''
                                    queryInfo.keyword = ''
                                    this.loadData()
                                  }}
                                />
                              }
                              onChange={(e) => {
                                queryInfo.search = e.target.value
                                this.setState({ queryInfo: queryInfo })
                              }}
                            />
                          </div>
                          <div class='card-body card-level-filter'>
                            <p class='hot-keyword-text'>
                              {__('熱門搜尋', 'cec-plugin-stores')}
                            </p>
                            <div>
                              <div
                                class='row no-gutters mx-n2 px-4'
                                id='item'>
                                {hotKeywords
                                  .filter(
                                    (word) => word.keyword.length <= 3,
                                  )
                                  .slice(0, 10)
                                  .map((hot) => {
                                    return (
                                      <div
                                        style={{ marginTop: '4px' }}
                                        class='col-auto px-1 hot-keywords'>
                                        <span
                                          class='hot-keyword'
                                          id={hot.keyword}
                                          role='button'
                                          onClick={() =>
                                            this.handleClickHot(hot)
                                          }>
                                          {hot.keyword}
                                        </span>
                                      </div>
                                    )
                                  })}
                              </div>
                            </div>
                          </div>
                          <div class='card-body card-level-filter'>
                            <a
                              class='btn'
                              data-toggle='collapse'
                              href='#typefilter'
                              role='button'
                              aria-expanded='false'
                              aria-controls='typefilter'>
                              {__('食材類別篩選', 'cec-plugin-stores')}
                            </a>
                            <div class='collapse show' id='typefilter'>
                              <div
                                class='row no-gutters mx-n2 px-4'
                                id='item'>
                                {recipeTags.map((tag) => {
                                  return (
                                    <div
                                      style={{ marginTop: '10px' }}
                                      class='col-auto px-2'>
                                      <span
                                        class={`keyword-btn ${
                                          queryInfo.keyword === tag.keyword
                                            ? 'active'
                                            : ''
                                        }`}
                                        id={tag.name}
                                        role='button'
                                        onClick={() =>
                                          this.handleClickTag(tag)
                                        }>
                                        {tag.name}
                                      </span>
                                    </div>
                                  )
                                })}
                              </div>
                            </div>
                          </div>
                          <div class='card-body card-level-filter'>
                            <a
                              class='btn d-none d-lg-flex'
                              data-toggle='collapse'
                              href='#recipeList'
                              role='button'
                              aria-expanded='false'
                              aria-controls='recipeList'>
                              {__('食譜分類', 'cec-plugin-stores')}
                            </a>
                            <div class='collapse show' id='recipeList'>
                              <div class='d-none d-lg-block'>
                                <div class='recipe-item my-4'>
                                  <ul>
                                    {recipeCategories.map((category) => {
                                      return (
                                        <li>
                                          <div
                                            onClick={() => {
                                              this.handleClickCategory(
                                                category,
                                              )
                                            }}>
                                            <a
                                              id={category.id}
                                              role='button'
                                              className={
                                                queryInfo.category_name ===
                                                category.name
                                                  ? 'active'
                                                  : null
                                              }>
                                              {category.name}
                                            </a>
                                          </div>
                                        </li>
                                      )
                                    })}
                                  </ul>
                                </div>
                              </div>
                            </div>
                            <div class='p-4 d-lg-none'>
                              <Select
                                defaultValue='disabled'
                                className=' bootstrap-select form-select '
                                onChange={this.recipeCategoriesSelect}>
                                <Select.Option value='disabled' disabled>
                                  請選擇食譜分類
                                </Select.Option>
                                {recipeCategories.map((category) => {
                                  return (
                                    <Select.Option
                                      key={category.id}
                                      value={category.name}>
                                      {category.name}
                                    </Select.Option>
                                  )
                                })}
                              </Select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </aside>
                  </div>
                  <div class='col-md-8 col-lg-9 mb-4'>
                    <div class='row kitchen-list no-gutters mx-n2'>
                      {recipeList.map((recipe) => {
                        return (
                          <div class='col-6 col-lg-3 px-2 mb-4'>
                            <a
                              class='card'
                              role='button'
                              href={`${INDEX_URL}/recipe-info${
                                Locale == 'en_US' ? '-en' : ''
                              }/?recipe=${recipe.name}`}>
                              <div class='card-img-top'>
                                <div
                                  class='img-1-1'
                                  style={{
                                    backgroundImage: `url('${_.get(
                                      recipe,
                                      'images.0',
                                    )}')`,
                                  }}
                                />
                              </div>
                              <div class='card-body'>
                                <h5 class='card-title'>{recipe.name}</h5>
                                <p class='card-text'>
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: recipe.desc,
                                    }}
                                  />
                                </p>
                              </div>
                            </a>
                          </div>
                        )
                      })}
                    </div>
                    <Pagination
                      current={listInfo.current}
                      pageSize={listInfo.page_size}
                      total={listInfo.total}
                      onChange={(page, pageSize) =>
                        this.handleChangePagination(page, pageSize)
                      }
                    />
                  </div>
                </div>
              </section>
            </div>
          </div>
        </main>
      </Fragment>
    )
  }
}

// 編輯器
export class NewsListEditor extends Component {
  formRef = React.createRef();
  state = {
    listInfo: _.cloneDeep(defaultListInfo),
  };

  componentDidMount() {
    AppHelper.updateConfig();
    this.formRef.current.setFieldsValue(this.props.attributes);
  }

  render() {
    return (
      <div className='vu-blocks-editor'>
        <div class='components-placeholder__label'>
          <span class='block-editor-block-icon'>
            <div class='dashicons dashicons-megaphone' />
          </span>
          食譜列表
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/blocks/recipes/recipe-list.js